import { Game } from "phaser";
import config from "./config";

export default new Game(config);
